import {
    GETUSERDETAILLIST_SUCCESS,
    GETUSERDETAILLIST_FAILED,
    RESET_GETUSERDETAILLIST,
    LOADING_GETUSERDETAILLIST,
    GETUSERDETAILLIST_NETWORKERROR,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETUSERDETAILLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GETUSERDETAILLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GETUSERDETAILLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case GETUSERDETAILLIST_NETWORKERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GETUSERDETAILLIST:
            return (state = initialState);
        default:
            return state;
    }
};
